import $ from "jquery";

import SyncableModel from "shared/syncable_model";

export default class BaseConnectApp extends SyncableModel {
  constructor(app, model) {
    super(model);
    this.app = app;
  }

  url() {
    return this.app.config.urlConfig.integration_status;
  }

  activateUrl() {
    return this.app.config.urlConfig.activate;
  }

  deactivateUrl() {
    return this.app.config.urlConfig.deactivate;
  }

  activateIntegration(successFn, errorFn) {
    var model = this;

    $.ajax({
      url: this.activateUrl(),
      method: 'POST',
      success: function(data, statusText) {
        successFn(model, data, statusText);
      },
      error: function(xhr, statusText, error) {
        errorFn(model, xhr, statusText, error);
      }
    });
  }

  deactivateIntegration(modalDialog, successFn, errorFn) {
    var model = this;

    $.ajax({
      url: this.deactivateUrl(),
      method: 'POST',
      success: function(data, statusText) {
        successFn(model, modalDialog, data, statusText);
      },
      error: function(xhr, statusText, error) {
        errorFn(model, modalDialog, xhr, statusText, error);
      }
    });
  }
}
